var metaCustomJs = document.querySelector('meta[name="custom-js"]');
let isFlatpickr  = false;
let isMoment     = false;

if (metaCustomJs != null) {
  if (metaCustomJs.getAttribute('custom-js') == 'true') {
    isFlatpickr = true;
    isMoment    = true;
  }
}

const $ = (
  await import(`${isFlatpickr ? `https://ga.jspm.io/npm:flatpickr@4.6.13/dist/esm/index.js` : `flatpickr`}`)
).default

const moment = (
  await import(`${isMoment ? `https://ga.jspm.io/npm:moment@2.29.4/moment.js` : `moment`}`)
).default

document.querySelectorAll('[data-date-target]').forEach(el => {
  const parent = el.closest('.form-wrapper')
  parent.addEventListener('click', e => {
    closeAllPopup()
    const child = e.currentTarget.querySelector('[data-date-target]')
    const target = child.getAttribute('data-date-target')
    const popup = document.querySelector(`#${target}`)
    popup.classList.toggle('show')
    const valueFromEl = e.currentTarget.querySelector('.date-from')
    const valueToEl = e.currentTarget.querySelector('.date-to')
    const value = child.value
    const backAction = child.getAttribute('data-back-popup')
    const dataDateValue = child.value
    const fromValue = valueFromEl?.value
    const toValue = valueToEl?.value
    const targetEl = popup.querySelector('.root-date-input')
    const dateFormat = child.getAttribute('format') || 'd-m-Y'
    const momentFormat = child.getAttribute('moment-format') || 'YYYY-MM-DD'

    // labeling text
    const dateFromText = popup.querySelector('.date-from')
    const dateToText = popup.querySelector('.date-to')

    let max = child.getAttribute('max') || null
    let min = child.getAttribute('min') || null

    let dateOptions = {
      dateFormat: dateFormat,
      inline: true,
    }

    let isRange = false

    if (max) {
      dateOptions.max = moment(max).toDate()
    }
    if (min) {
      dateOptions.min = moment(min).toDate()
    }
    if (valueFromEl && valueToEl) {
      isRange = true
      dateOptions.mode = 'range'
      console.log([moment(fromValue, momentFormat), moment(toValue, momentFormat)])
      if (fromValue) {
        dateOptions.defaultDate = [moment(fromValue, momentFormat).toDate(), moment(value, momentFormat).toDate()]
      }
      if (toValue) {
        dateOptions.defaultDate = [moment(value, momentFormat).toDate(), moment(toValue, momentFormat).toDate()]
      }
      if (fromValue && toValue) {
        dateOptions.defaultDate = [moment(fromValue, momentFormat).toDate(), moment(toValue, momentFormat).toDate()]
      }
    } else {
      dateOptions.defaultDate = moment(dataDateValue, momentFormat).toDate()
    }

    flatpickr(targetEl, {
      ...dateOptions,
      onChange: function (selectedDates) {
        if (dateFromText) {
          if (selectedDates[0]) {
            dateFromText.innerHTML = moment(selectedDates[0]).format(momentFormat)
          } else {
            dateFromText.innerHTML = '-'
          }
        }
        if (dateToText) {
          if (selectedDates[1]) {
            dateToText.innerHTML = moment(selectedDates[1]).format(momentFormat)
          } else {
            dateToText.innerHTML = '-'
          }
        }
      },
    })

    if (backAction) {
      popup.setAttribute('data-back-popup', backAction)
      popup.querySelector('.back-action').classList.remove('d-none')
    }

    popup.querySelectorAll('.btn-update-date').forEach(el => {
      el.addEventListener('click', () => {
        const flatpickrRoot = targetEl?._flatpickr
        if (isRange) {
          child.value = `${moment(flatpickrRoot?.selectedDates[0]).format(momentFormat)} - ${moment(
            flatpickrRoot?.selectedDates[1]
          ).format(momentFormat)}`

          valueFromEl.value = moment(flatpickrRoot?.selectedDates[0]).format(momentFormat)
          valueToEl.value = moment(flatpickrRoot?.selectedDates[1]).format(momentFormat)
        } else {
          child.value = moment(flatpickrRoot?.selectedDates[0]).format(momentFormat)
        }
        popup.classList.remove('show')
        postProcessClosePopup(popup)
      })
    })
  })
})
